module.exports = __webpack_public_path__ + "img/628767df0207dd78ab6e7d7b.bed19f5f.svg";